<template>
  <el-form class="login-form" ref="loginForm" :model="user">
    <h3 class="login-form__title">{{ appName }}</h3>

    <div v-if="error" class="login-form__error">
      <i class="el-icon-warning-outline"></i>
      <span class="login-form__error_message">{{ error }}</span>
    </div>

    <el-form-item class="login-form__item" :label="$t('login_username')">
      <el-input v-model="user.login" :autofocus="autofocusLogin"></el-input>
    </el-form-item>

    <el-form-item class="login-form__item" :label="$t('login_password')">
      <el-input
        v-model="user.password"
        show-password
        :autofocus="autofocusPassword"
        @keyup.enter.native="onSignIn"
      ></el-input>
    </el-form-item>

    <el-form-item class="login-form__item login-form__action">
      <el-button type="primary" :disabled="disabledAction" @click="onSignIn">
        {{ $t("login_sing_in") }}
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: "TheLoginForm",
  props: {
    defaultUserName: String,
    appName: String,
    status: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      user: {
        login: "",
        password: ""
      },
      error: "",
      timerId: 0,
      interval: 0,
      errorMethod: {
        0: this.noError,
        401: this.notAuth,
        403: this.forbidden,
        423: this.lock
      }
    };
  },
  computed: {
    intervalFormat() {
      return this.timeFormat(this.interval, ":", false);
    },
    disabledAction() {
      return !this.user.login || !this.user.password;
    },
    autofocusLogin() {
      return !this.user.login || !this.defaultUserName;
    },
    autofocusPassword() {
      return this.user.login;
    }
  },
  methods: {
    timeFormat(time, seporator, zeroStart) {
      let t = time / 60;
      let mod = time % 60;
      let ft;

      if (mod === 0) {
        ft = zeroStart ? t.toString().padStart(2, "0") : t;
        return ft + seporator + "00";
      } else {
        ft = zeroStart
          ? Math.floor(t).toString().padStart(2, "0")
          : Math.floor(t);
        return ft + seporator + mod.toString().padStart(2, "0");
      }
    },
    runTimer() {
      this.error = this.$t("auth_403_error", { time: this.intervalFormat });
      this.interval--;
      if (this.interval <= 0) {
        this.resetTimer();
        this.error = "";
      }
    },
    onSignIn() {
      if (!this.disabledAction) {
        return this.$emit("onSignIn", this.user);
      }
    },
    presetLogin() {
      if (this.defaultUserName) {
        this.user.login = this.defaultUserName;
      }
    },
    resetTimer() {
      this.interval = 0;
      if (this.timerId) {
        clearInterval(this.timerId);
      }
    },
    noError() {
      this.resetTimer();
      this.error = "";
    },
    notAuth() {
      this.resetTimer();
      this.error = this.$t("auth_401_error");
    },
    forbidden() {
      this.resetTimer();
      this.interval = 10 * 60; // 10 minute
      this.timerId = setInterval(this.runTimer, 1000);
    },
    lock() {
      this.resetTimer();
      this.error = this.$t("auth_423_error");
    },
    changeStatus() {
      if (this.errorMethod[this.status]) {
        this.errorMethod[this.status]();
      } else {
        this.error = "";
      }
    }
  },
  mounted() {
    this.presetLogin();
  },
  watch: {
    status: function () {
      this.changeStatus();
    }
  }
};
</script>

<style lang="scss" scoped>
.login-form {
  width: 300px;
  border: 1px solid #c0c4cc;
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  background-color: #fff;
  padding-top: 5px;

  .login-form__title {
    text-align: center;
  }

  .login-form__item {
    padding: 0 10px;
  }

  .login-form__action {
    text-align: right;
  }

  .login-form__error {
    font-size: 14px;
    margin: 5px 10px;
    margin-bottom: 15px;
    background-color: #f2f6fc;
    padding: 5px;

    .login-form__error_message {
      margin-left: 3px;
    }
  }
}
</style>
